const route = {
    path: '/playlists',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(
                        /* webpackChunkName: "playlists" */
                        '../../components/views/playlists/groupOverview.vue'
                        ),
            }
        },
        {
            path: ':group',
            components: {
                default:
                    () => import(
                        /* webpackChunkName: "playlists" */
                        '../../components/views/playlists/playlists.vue'
                        ),
            }
        },
        {
            path: ':group/:playlist',
            components: {
                default:
                    () => import(
                        /* webpackChunkName: "playlists" */
                        '../../components/views/playlists/playlist.vue'
                        ),
            }
        },
    ],
}

module.exports = route;